import { hasInjectionContext, inject, InjectionKey } from 'vue';

export const suspendInjectionKey = Symbol('suspend') as InjectionKey<Suspend>;

/**
 * Course suspend state from the root `App` provide.
 *
 * Returns `undefined` when there is no active injection context (e.g. composables
 * invoked from async timers after `setup` has finished). Callers should use
 * optional chaining or fallbacks — do not call `inject()` in that case or Vue
 * warns: "inject() can only be used inside setup()".
 */
export default function useSuspend(): Suspend | undefined {
  if (!hasInjectionContext()) {
    return undefined;
  }
  return inject(suspendInjectionKey, undefined);
}
